import { Box, Typography } from "@mui/material";
import React from "react";
import { brand } from "../../../shared/theme/app-theme";
import {
  getReportStatusLabel,
  ReportStatus,
  REPORT_UPLOAD_FAILED_LABEL,
} from "../models";

/** Quiet, high-contrast dots — not a traffic-light flood */
export const ReportStatusColors: Record<ReportStatus, string> = {
  [ReportStatus.LOADED]: "#5a6780",
  [ReportStatus.PENDING]: "#9a6b12",
  [ReportStatus.FOR_REVISION]: "#b42318",
  [ReportStatus.ACCEPTED]: "#19286d",
  [ReportStatus.SCHOLARSHIP_CALCULATION]: "#0068b4",
  [ReportStatus.APPROVED_BY_UNIVERSITY]: "#0f6b5c",
  [ReportStatus.MT102]: "#3d5a80",
  [ReportStatus.MT102_CREATED]: "#3d5a80",
  [ReportStatus.PAID_IN_PART]: "#2f6f4e",
  [ReportStatus.PAID]: "#1f7a4d",
  [ReportStatus.ERROR]: "#b42318",
};

type Props = {
  status?: ReportStatus | null;
  failed?: boolean;
  label?: string;
};

const ReportStatusIndicator: React.FC<Props> = ({ status, failed, label }) => {
  const color = failed
    ? ReportStatusColors[ReportStatus.ERROR]
    : status
      ? ReportStatusColors[status] ?? brand.muted
      : ReportStatusColors[ReportStatus.LOADED];
  const text = failed
    ? label || REPORT_UPLOAD_FAILED_LABEL
    : label || getReportStatusLabel(status);

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1,
        minWidth: 0,
      }}
    >
      <Box
        component="span"
        sx={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          bgcolor: color,
          flexShrink: 0,
        }}
      />
      <Typography
        component="span"
        sx={{
          fontSize: 13,
          fontWeight: 500,
          color: brand.ink,
          lineHeight: 1.3,
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default ReportStatusIndicator;
